import * as React from 'react';
import { useRef } from 'react';
import GridConfig from './GridConfig';
import CommonGrid from '../../../../../../common/GridWithHeader/CommonGrid';
import { RouteAuditData, RouteAuditRecord } from '../../../IRouteAudit';

interface AuditGridProps {
  data: RouteAuditData | null;
  onRowsSelected: (records: RouteAuditRecord[]) => void;
  onToggleGridMaximize: (isMaximized: boolean) => void;
  visible: boolean;
  userData: any;
}

const AuditGrid = ({
  data,
  onRowsSelected,
  onToggleGridMaximize,
  visible,
  userData
}: AuditGridProps) => {
  const gridConfig = useRef(new GridConfig({ userConfig: userData.userProfile?.columnPref }));

  return (
    <CommonGrid
      title="Routes"
      exportFileName="route-audit"
      data={data as RouteAuditRecord[]}
      config={gridConfig.current.config}
      onToggleGridMaximize={onToggleGridMaximize}
      onRowsSelected={onRowsSelected}
      isVisible={visible}
    />
  );
};

export default AuditGrid;
